angular.module('SpidApp')

.factory('StampReconciliation', [
      '$q'
    
    , 'AffranchissementService'
    , 'ChoixOptionAffranchissementDestinationService'
    , 'ComplementServiceAffranchissementDestinationService'
    , 'DestinationService'
    , 'DestinationZoneService'
    , 'OptionAffranchissementDestinationService'
    , 'PrixServiceAffranchissementDestinationService'
    , 'PrixTrancheAffranchissementZoneService'
    , 'RestrictionService'
    , 'ServiceAffranchissementDestinationService'
    , 'ZoneAffranchissementService'
, function (
      $q
    
    , AffranchissementService
    , ChoixOptionAffranchissementDestinationService
    , ComplementServiceAffranchissementDestinationService
    , DestinationService
    , DestinationZoneService
    , OptionAffranchissementDestinationService
    , PrixServiceAffranchissementDestinationService
    , PrixTrancheAffranchissementZoneService
    , RestrictionService
    , ServiceAffranchissementDestinationService
    , ZoneAffranchissementService
    ) {
    
    var StampReconciliation = {
        fetchAll: function () {
            return $q.all([
                  AffranchissementService.all()
                , ChoixOptionAffranchissementDestinationService.all()
                , ComplementServiceAffranchissementDestinationService.all()
                , DestinationService.all()
                , DestinationZoneService.all()
                , OptionAffranchissementDestinationService.all()
                , PrixServiceAffranchissementDestinationService.all()
                , PrixTrancheAffranchissementZoneService.all()
                , RestrictionService.all()
                , ServiceAffranchissementDestinationService.all()
                , ZoneAffranchissementService.all()
            ]).then(function (response) {
                return {
                      affranchissement                             : response[ 0]
                    , choixOptionAffranchissementDestination       : response[ 1]
                    , complementServiceAffranchissementDestination : response[ 2]
                    , destination                                  : response[ 3]
                    , destinationZone                              : response[ 4]
                    , optionAffranchissementDestination            : response[ 5]
                    , prixServiceAffranchissementDestination       : _.chain(response[ 6]).reduce(function (memo, elem) {
                        var key = elem.code_service_speciaux + '-' + elem.code_affranchissement+ '-' + elem.code_destination
                        memo[key] = memo[key] || elem

                        if (!elem.unite) {
                            return memo
                        }
                        
                        memo[key].tranches = memo[key].tranches || []
                        memo[key].tranches.push({tranche_inferieure: elem.tranche_inferieure, tranche_superieure: elem.tranche_superieure, prix: elem.prix})
                        
                        return memo
                    }, {}).values().value()
                    , prixTrancheAffranchissementZone              : response[ 7]
                    , restriction                                  : response[ 8]
                    , serviceAffranchissementDestination           : response[ 9]
                    , zoneAffranchissement                         : response[10]
                }
            })
        }
    }
    
    return StampReconciliation
}])
